import styled, { css } from 'styled-components';

import { FontSizes, FontWeights, Text } from '@calm-web/design-system';

export const CopyWrapper = styled.div``;

export const Name = styled(Text).attrs({
	color: 'white',
	size: FontSizes.lg,
	weight: FontWeights.Medium,
	noMargin: true,
	el: 'p',
})``;

export const Bio = styled(Text).attrs({
	color: 'gray2',
	size: FontSizes.sm,
	weight: FontWeights.Regular,
	noMargin: true,
	el: 'p',
})`
	margin-bottom: 8px;
`;

export const masterClassWrapper = css`
	align-items: center;
	display: ${p => (p.theme === 'masterclass' ? 'flex' : 'block')};
	margin: 24px 0;

	${CopyWrapper} {
		margin-left: 16px;
	}
`;

export const Wrapper = styled.div<{
	theme: 'default' | 'masterclass';
}>`
	${p => p.theme === 'masterclass' && masterClassWrapper}
`;
